import { useIsSplitEnabled } from '@buffer-mono/features'
import {
  Dialog,
  DropdownMenu,
  RepeatIcon,
  useDropdownMenu,
} from '@buffer-mono/popcorn'

import { usePostData } from '../PostCardContext'
import { RecurrenceSettingsDialogContent } from './RecurrenceSettingsDialog'

import type { JSX } from 'react'

type DialogMode = 'create' | 'edit'

export function SetRecurrenceMenuItem(): JSX.Element | null {
  const { id, allowedActions, dueAt, recurrence, channel } = usePostData()
  const { close: closeDropdown } = useDropdownMenu()
  const isRecurringPostsEnabled = useIsSplitEnabled('publish-recurring-posts')

  if (!isRecurringPostsEnabled) {
    return null
  }

  const canCreate = allowedActions.includes('createPostRecurrence')
  const canEdit = allowedActions.includes('editPostRecurrence')

  if (!canCreate && !canEdit) {
    return null
  }

  const mode: DialogMode = canEdit ? 'edit' : 'create'
  const label = canEdit ? 'Edit Recurrence' : 'Make Recurring'

  const handleDialogOpenChange = (open: boolean): void => {
    if (!open) {
      closeDropdown()
    }
  }

  return (
    <Dialog onOpenChange={handleDialogOpenChange}>
      <Dialog.Trigger>
        <DropdownMenu.Item
          onSelect={(e): void => {
            e.preventDefault()
          }}
        >
          <RepeatIcon />
          {label}
        </DropdownMenu.Item>
      </Dialog.Trigger>
      <RecurrenceSettingsDialogContent
        onOpenChange={handleDialogOpenChange}
        mode={mode}
        postId={id}
        channelId={channel.id}
        channelType={channel.type}
        channelService={channel.service}
        dueAt={dueAt}
        recurrence={recurrence}
      />
    </Dialog>
  )
}
